export const SHOWCASE_URL = "/sydney-court-resurfacing-guides";
export const MOBILE_URL = "/sydney-court-resurfacing-mobile";
export const WHATSAPP_NUMBER = "61466495495";
export const DEFAULT_WA = "Hi Speedy Resurfacing, I'd like a quote for court resurfacing in Sydney.";

export const waLink = (message) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// ?sport= deep links for Google Ads sitelinks / RSA final URLs → pins that act to #1 and swaps the hero copy
export const SPORT_PARAMS = {
  pickleball: { slug: "pickleball-court-resurfacing-sydney", h1: "PICKLEBALL COURT RESURFACING", sub: "MULTI-SPORT CONVERSIONS & PRECISION KITCHEN LINES ACROSS SYDNEY", seo: "Pickleball Court Resurfacing Sydney" },
  netball: { slug: "netball-court-resurfacing-sydney", h1: "NETBALL COURT RESURFACING", sub: "REGULATION-GRADE, NON-SLIP NETBALL COURTS ACROSS SYDNEY", seo: "Netball Court Resurfacing Sydney" },
  basketball: { slug: "the-custom-5", h1: "BASKETBALL COURT RESURFACING", sub: "CUSTOM FIVE-COLOUR BASKETBALL COURTS ACROSS SYDNEY", seo: "Basketball Court Resurfacing Sydney" },
  tennis: { slug: "tennis-court-resurfacing-sydney", h1: "TENNIS COURT RESURFACING", sub: "CLUB-GRADE ACRYLIC TENNIS COURTS ACROSS SYDNEY", seo: "Tennis Court Resurfacing Sydney" },
  school: { slug: "restoring-school-sports-courts-sydney", h1: "SCHOOL COURT RESURFACING", sub: "MULTI-SPORT SCHOOL COURTS RESURFACED IN THE HOLIDAYS", seo: "School Sports Court Resurfacing Sydney" },
  sda: { slug: "sda-housing-external-environments-accessibility-sydney", h1: "ACCESSIBLE & SDA SURFACES", sub: "AS2890.6 ACCESSIBLE BAYS, PATHWAYS & INCLUSIVE COURTS", seo: "Accessible Parking & SDA External Surfaces Sydney" },
  custom: { slug: "beyond-the-baseline", h1: "CUSTOM COURT DESIGN", sub: "COLOUR, BRANDING & PREMIUM ACRYLIC ACROSS SYDNEY", seo: "Custom Court Design & Resurfacing Sydney" },
};
SPORT_PARAMS.accessible = SPORT_PARAMS.sda;
SPORT_PARAMS.schools = SPORT_PARAMS.school;

export const sportKeyForSlug = (slug) => Object.keys(SPORT_PARAMS).find((k) => SPORT_PARAMS[k].slug === slug) || slug;

export const ACTS = {
  "pickleball-court-resurfacing-sydney": {
    sport: "Pickleball",
    act: "The Pickleball Breakout",
    headline: "LOW BOUNCE. HIGH GRIP. ZERO BLEED.",
    pitch: "Sydney's fastest-growing sport deserves a court that plays true — multi-layer UV-stable acrylic, silica-textured traction and kitchen lines set out to the millimetre. Tennis-to-pickleball conversions fit up to four regulation courts on one footprint.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for pickleball court resurfacing or a tennis-to-pickleball conversion in Sydney.",
    points: [
      "Up to four regulation pickleball courts on one tennis court footprint",
      "UV-stabilised acrylic that flexes with Sydney's heat and humidity",
      "Kitchen, baselines and sidelines by Speedy Line Marking — zero paint bleed",
      "Concrete or asphalt bases · 5–8 year lifespan",
    ],
    geo: ["Inner West", "Northern Beaches", "North Shore", "Western Sydney"],
  },
  "netball-court-resurfacing-sydney": {
    sport: "Netball",
    act: "The Netball Set",
    headline: "GRIP THAT NEVER QUITS.",
    pitch: "Netball courts across Sydney restored to regulation grade — non-slip texture that holds a hard stop, sealed cracks that stay sealed, and Netball Australia-compliant lines. Back in play in 3–5 days.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for netball court resurfacing in Sydney.",
    points: [
      "6-stage system: grind, crack repair, base coat, non-slip texture, precision lines",
      "Rounded-silica non-slip texture tuned to netball traction demands",
      "Netball Australia-compliant goal circles and thirds set out by Speedy Line Marking",
      "5–8+ year lifespan vs 1–2 for a paint job",
    ],
    geo: ["Parramatta", "Penrith", "North Shore", "Sutherland Shire"],
  },
  "the-custom-5": {
    sport: "Basketball",
    act: "The Basketball Feature",
    headline: "YOUR COURT. YOUR COLOURS. YOUR ARENA.",
    pitch: "Five-colour custom basketball courts designed in 3D and delivered in Sydney backyards, schools and clubs — keys, three-point zones and logos in UV-stable acrylic that holds its colour through Western Sydney summers.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for a custom basketball court in Sydney.",
    points: [
      "Preview your exact colours in the 3D Court Customiser before we quote",
      "Backyard half-courts through to full-size school and club layouts",
      "UV-stable acrylic built for Sydney heat and rain",
      "Every line set out by the Speedy Line Marking crew",
    ],
    geo: ["Western Sydney", "Hills District", "Inner West", "Northern Beaches"],
  },
  "tennis-court-resurfacing-sydney": {
    sport: "Tennis",
    act: "The Tennis Headliner",
    headline: "PLAY TRUE. LOOK PRO.",
    pitch: "Club-grade tennis court resurfacing with consistent bounce, controlled pace and premium two-tone presentation — cracks and drainage fixed before a drop of colour goes down.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for tennis court resurfacing in Sydney.",
    points: [
      "Cushioned or hard acrylic systems matched to your club or backyard",
      "Consistent pace and bounce from an engineered surface texture",
      "Crack repair and drainage corrected first, every time",
      "Two-tone courts and surrounds for a photo-ready finish",
    ],
    geo: ["Eastern Suburbs", "North Shore", "Sutherland Shire", "Wollongong"],
  },
  "restoring-school-sports-courts-sydney": {
    sport: "School Courts",
    act: "The School Courts Revival",
    headline: "SAFER PLAYGROUNDS BY MONDAY MORNING.",
    pitch: "Multi-sport school courts resurfaced over the holidays by a Cm3-prequalified crew — netball, basketball and handball lines on one bright, non-slip slab, with zero disruption to the timetable.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for resurfacing our school sports courts in Sydney.",
    points: [
      "Multi-sport overlays — netball, basketball and handball on one slab",
      "Non-slip, low-abrasion texture that is kind on knees and elbows",
      "Holiday-period scheduling with zero disruption to classes",
      "Cm3-prequalified — WHS paperwork done before we arrive",
    ],
    geo: ["Greater Sydney", "Liverpool", "Blacktown", "Campbelltown"],
  },
  "sda-housing-external-environments-accessibility-sydney": {
    sport: "Accessible & SDA",
    act: "The Accessibility Movement",
    headline: "ACCESSIBILITY THAT REACHES THE CAR PARK.",
    pitch: "AS2890.6 accessible parking bays, non-slip pathways and inclusive recreation courts for SDA and NDIS providers — so the participant's day works from the moment they leave the vehicle.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for accessible parking line marking and external surfaces at an SDA site in Sydney.",
    points: [
      "AS2890.6 accessible bays, shared zones and ISA stencils by Speedy Line Marking",
      "Non-slip, level pathways and courtyards for heavy wheelchair traffic",
      "Inclusive recreation courts for NDIS participants",
      "External Asset Maintenance Plans that keep sites compliant",
    ],
    geo: ["Campbelltown", "Liverpool", "Camden", "Blacktown"],
  },
  "beyond-the-baseline": {
    sport: "Custom Courts",
    act: "The Opening Number",
    headline: "WHERE COURT IDENTITY BEGINS.",
    pitch: "Colour, branding and premium multi-layer acrylic from the Speedy Line Marking lineage — the guide to turning a tired slab into a court people photograph.",
    whatsapp: "Hi Speedy Resurfacing, I'd like a quote for court resurfacing and custom design in Sydney.",
    points: [
      "Custom colour, branding and court identity from concept to handover",
      "Premium multi-layer acrylic systems engineered for Sydney's climate",
      "Precision line marking heritage on every project",
      "Sydney-wide from our Merrylands headquarters",
    ],
    geo: ["Sydney CBD", "Merrylands", "Newcastle", "Canberra"],
  },
};
